/** AI B2B Leads: download a CSV of leads. The server builds the file (and defuses spreadsheet formulas); this only fetches it. */
import { apiRequest } from "@/lib/queryClient";

/** `columns`: the enrichment fields the person ticked, so the file has what the table shows. Left out = the original 16. */
export type ExportRequest = { columns?: string[] } & (
  | { scope: "ids"; ids: string[] }
  | { scope: "search"; jobId: string }
  | { scope: "leads"; status?: "new" | "added"; hasPhone?: "yes" | "no"; search?: string }
);

export interface ExportResult {
  /** Rows in the file. */
  rows: number;
  /** Rows there were: more than `rows` when the server capped the file. */
  total: number;
  filename: string;
}

export async function downloadLeadsCsv(request: ExportRequest): Promise<ExportResult> {
  const res = await apiRequest("POST", "/api/prospect-leads/export", request);
  const blob = await res.blob();
  const filename = /filename="([^"]+)"/.exec(res.headers.get("Content-Disposition") ?? "")?.[1] ?? "leads.csv";
  const rows = Number(res.headers.get("X-Export-Rows") ?? "0");
  const total = Number(res.headers.get("X-Export-Total") ?? String(rows));

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
  return { rows, total, filename };
}
